import moment from "moment";

export const formateDate = (data) => {
    return moment(data).format("MM/DD/YYYY");
}

export const formateTime = (data) => {
    return moment(data).format("LT");
}